import { Pipe, PipeTransform } from '@angular/core';

import { VehicleOperationalStatusStoreModelEnum } from '@domain/single-site/single-site.enums';

import { TranslateEnumPipeBase } from '@shared/pipes/translate-enum-pipe-base';

const KEY_PREFIX = 'enums.vehicle-status-capitalized';
export const VehicleStatusKeyMapping: Record<VehicleOperationalStatusStoreModelEnum, string> = {
  [VehicleOperationalStatusStoreModelEnum.Ready]: `${KEY_PREFIX}.ready`,
  [VehicleOperationalStatusStoreModelEnum.Charging]: `${KEY_PREFIX}.charging`,
  [VehicleOperationalStatusStoreModelEnum.Queued]: `${KEY_PREFIX}.queued`,
  [VehicleOperationalStatusStoreModelEnum.Faulted]: `${KEY_PREFIX}.faulted`,
  [VehicleOperationalStatusStoreModelEnum.InDepot]: `${KEY_PREFIX}.in-depot`,
  [VehicleOperationalStatusStoreModelEnum.OnTheRoad]: `${KEY_PREFIX}.on-the-road`,
  [VehicleOperationalStatusStoreModelEnum.Unknown]: `${KEY_PREFIX}.unknown`,
};

@Pipe({
  name: 'appTranslateVehicleStatusCapitalized',
  pure: false,
  standalone: true,
})
export class TranslateVehicleStatusCapitalizedPipe
  extends TranslateEnumPipeBase<VehicleOperationalStatusStoreModelEnum>
  implements PipeTransform
{
  protected readonly valueTranslateKeyMap = VehicleStatusKeyMapping;
}
